import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchPublicWatch } from './api';
import { ApiError } from './api';
import { HlsPlayer } from './hls-player';
import { PublicWatchPayload } from './types';

type WatchState =
  | { kind: 'loading' }
  | { kind: 'ready'; payload: PublicWatchPayload }
  | { kind: 'unavailable' }
  | { kind: 'throttled' };

export function WatchPage() {
  const { uploadId } = useParams<{ uploadId: string }>();
  const [state, setState] = useState<WatchState>({ kind: 'loading' });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      if (!uploadId) {
        setState({ kind: 'unavailable' });
        return;
      }
      try {
        const payload = await fetchPublicWatch(uploadId);
        if (cancelled) return;
        if (!payload) setState({ kind: 'unavailable' });
        else setState({ kind: 'ready', payload });
      } catch (e) {
        if (cancelled) return;
        if (e instanceof ApiError && e.status === 429) setState({ kind: 'throttled' });
        else setState({ kind: 'unavailable' });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [uploadId]);

  return (
    <div className="app-shell">
      <header className="app-header">
        <strong>VOD Management</strong>
      </header>
      {state.kind === 'loading' && <p className="muted">Loading…</p>}
      {state.kind === 'ready' && (
        <div>
          <h1 style={{ marginBottom: 'var(--space-3)' }}>{state.payload.filename || 'Video'}</h1>
          <HlsPlayer
            src={state.payload.hlsUrl}
            poster={state.payload.thumbnailUrl}
            captionUrl={state.payload.captionUrl}
          />
        </div>
      )}
      {state.kind === 'unavailable' && (
        <div className="card" style={{ textAlign: 'center' }}>
          <h1>This video is not available</h1>
          <p className="muted">
            The link may be invalid, the video may have been removed, or processing may still be in
            progress.
          </p>
        </div>
      )}
      {state.kind === 'throttled' && (
        <div className="card" style={{ textAlign: 'center' }}>
          <h1>Please try again later</h1>
          <p className="muted">This page is busy. Wait a moment and reload.</p>
        </div>
      )}
    </div>
  );
}
